import { BootScene } from './scenes/BootScene';
import { MenuScene } from './scenes/MenuScene';
import { GameScene } from './scenes/GameScene';
import { ShopScene } from './scenes/ShopScene';
import { Game } from './core/Game';

const container = document.getElementById('game');

async function main() {
  if (!container) {
    document.body.innerHTML = '<h2 style="color:white">Game container not found</h2>';
    return;
  }

  try {
    const game = new Game({
      container,
      width: window.innerWidth,
      height: window.innerHeight,
      scenes: {
        boot: BootScene,
        menu: MenuScene,
        game: GameScene,
        shop: ShopScene,
      },
      initialScene: 'boot',
    });

    await game.start();
    console.log('Game loaded successfully!');
  } catch (err) {
    console.error('Game init error:', err);
    container.innerHTML = `
      <div style="color:white;padding:20px;font-family:Arial;">
        <h2>Ошибка загрузки</h2>
        <p>${err instanceof Error ? err.message : String(err)}</p>
        <p>Попробуй обновить страницу (F5)</p>
      </div>
    `;
  }
}

main();
